import { Button, Tooltip } from '@mui/material';
import { useRef, ReactNode } from 'react';
import { SaveAlt } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

import { SALES_RESULT_WIDTH, SALES_RESULT_HEIGHT } from './SalesResult';
import useSvgForeignObjectScreenshot from 'src/infrastructure/image/useSvgForeignObjectScreenshot';
import { downloadFileFromDataUrl } from 'src/common/downloadFile';

export default function SalesPrint({
    children,
    projectName,
    energyConsumption,
    plot,
}: {
    children: ReactNode;
    projectName: string;
    energyConsumption: ReactNode;
    plot: ReactNode;
}) {
    const { t } = useTranslation();

    const salesPrintRef = useRef(null);
    const screenshot = useSvgForeignObjectScreenshot();

    const downloadImage = async () => {
        if (salesPrintRef.current === null) {
            return;
        }

        const canvas = await screenshot.screenshot(salesPrintRef.current, {
            width: SALES_RESULT_WIDTH,
            height: SALES_RESULT_HEIGHT,
        });

        downloadFileFromDataUrl(canvas.toDataURL('image/png'), `${projectName}.png`.replaceAll(' ', '_'));
    };

    return (
        <div className="sales sales_count1">
            <div id="objects" ref={salesPrintRef}>
                <h3>{projectName}</h3>
                <article>
                    <div className="section_img">
                        {energyConsumption}
                        {plot}
                    </div>

                    <div className="section_variants">{children}</div>
                </article>
            </div>

            <div style={{ float: 'left', paddingBottom: 10 }}>
                <Tooltip title={t('Please enter a project name first.')} disableHoverListener={projectName !== ''}>
                    <span>
                        <Button
                            variant="contained"
                            onClick={() => downloadImage()}
                            startIcon={<SaveAlt />}
                            disabled={projectName === ''}
                        >
                            {t('Save Image')}
                        </Button>
                    </span>
                </Tooltip>
            </div>
        </div>
    );
}
